import React from "react";
import { render } from "react-dom";
import { createStore, applyMiddleware } from "redux";
import { Provider } from "react-redux";
import {  
  Router,  
  hashHistory,
} from "react-router";
import { syncHistoryWithStore, routerMiddleware } from "react-router-redux";
import { persistStore, autoRehydrate } from "redux-persist";
import { composeWithDevTools } from "redux-devtools-extension";
import ReactGA from "react-ga";
import reducers from "./reducers";

const middleware = routerMiddleware(hashHistory);
const store = createStore(
  reducers,
  composeWithDevTools(applyMiddleware(middleware)),
  autoRehydrate()
);

ReactGA.initialize("UA-154896906-1"); //UA-154749682-1
ReactGA.pageview("/inicio");

persistStore(store, { blacklist: ["routing"] });

const history = syncHistoryWithStore(hashHistory, store);

function scrollToTop() {
  window.scrollTo(0, 0);
}

const rootRoute = {
  path: "/",
  indexRoute: { onEnter: (nextState, replace) => replace("/inicio") },
  component: require("./containers/App"),
  childRoutes: [
    // Not-authenticated   
    {
      childRoutes: [
        require("./routes/app"),
        require("./routes/404"),        
        require("./routes/inicio")
      ]
    },
    {
      path: "*",
      indexRoute: { onEnter: (nextState, replace) => replace("/") }
    }
  ]
};

render(
  <Provider store={store}>
    <Router onUpdate={scrollToTop} history={history} routes={rootRoute} />
  </Provider>,
  document.getElementById("app-container")
);



// WEBPACK FOOTER //
// ./client.js